import * as storage from '../../utils/storage';

export const OnboardingModal = ({
  showOnboarding,
  onboardingCard,
  setOnboardingCard,
  setShowOnboarding,
  username,
  setShowUsernameSetup,
}) => {
  if (!showOnboarding) return null;

  return (
    <div className="fixed inset-0 z-[9000] bg-black/95 flex items-center justify-center p-3 sm:p-4">
      <div
        className="bg-gradient-to-br from-gray-900 to-black border-4 border-lime-500 p-4 sm:p-6 md:p-8 max-w-2xl w-full [&::-webkit-scrollbar]:hidden"
        style={{
          maxHeight: 'calc(100dvh - 1.5rem)',
          overflowY: 'auto',
          overflowX: 'hidden',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }}
      >
        {/* Card 1: The Hook */}
        {onboardingCard === 1 && (
          <div className="text-center">
            <div className="mb-6 sm:mb-8 w-full">
              <div className="relative w-full">
                <h1 className="font-black tracking-tighter mb-4 leading-none whitespace-nowrap text-center" style={{
                  fontSize: 'clamp(1.8rem, 11.5vw, 5rem)',
                  background: 'linear-gradient(45deg, #00ff00, #ffff00)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  color: 'transparent',
                  textShadow: '0 0 40px rgba(0,255,0,0.5)'
                }}>
                  SENDITMAXX
                </h1>
                <div className="absolute -inset-4 bg-gradient-to-r from-lime-500/20 to-yellow-500/20 blur-xl -z-10"></div>
              </div>
            </div>

            <div className="bg-gradient-to-r from-lime-500 to-yellow-400 px-4 sm:px-8 py-3 sm:py-4 inline-block mb-6 sm:mb-8 skew-x-[-5deg]">
              <p className="text-black text-xl sm:text-3xl md:text-4xl font-black uppercase tracking-wider skew-x-[5deg]">
                STOP OVERTHINKING
              </p>
            </div>

            <div className="mb-6 sm:mb-8">
              <p className="text-white text-lg sm:text-2xl md:text-3xl font-black uppercase mb-4 sm:mb-6">
                JUST SEND IT
              </p>
              <p className="text-gray-400 text-sm sm:text-lg font-bold max-w-lg mx-auto">
                No more endless planning. No more optimization paralysis. Daily challenges force action over analysis.
              </p>
            </div>

            <button
              onClick={() => setOnboardingCard(2)}
              className="w-full bg-gradient-to-r from-lime-500 to-green-600 hover:from-lime-400 hover:to-green-500 text-black py-4 sm:py-6 font-black text-xl sm:text-3xl uppercase border-4 border-lime-400 transition-all"
            >
              START →
            </button>
          </div>
        )}

        {/* Card 2: The Rules */}
        {onboardingCard === 2 && (
          <div className="text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-yellow-500 uppercase mb-4 sm:mb-6 tracking-tight">
              THE RULES
            </h2>

            <div className="space-y-3 sm:space-y-4 mb-4 sm:mb-6 text-left">
              {/* Daily Challenge */}
              <div className="bg-gradient-to-r from-lime-500/20 to-green-500/20 border-2 border-lime-500 p-3 sm:p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="text-2xl sm:text-3xl">⚡</div>
                  <h3 className="text-base sm:text-xl font-black text-lime-400 uppercase">Daily Challenge</h3>
                </div>
                <p className="text-white font-bold text-xs sm:text-sm">
                  Do it or lose your streak. No excuses.
                </p>
              </div>

              {/* Streak System */}
              <div className="bg-gradient-to-r from-orange-500/20 to-red-500/20 border-2 border-orange-500 p-3 sm:p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="text-2xl sm:text-3xl">🔥</div>
                  <h3 className="text-base sm:text-xl font-black text-orange-400 uppercase">Streak Breaks</h3>
                </div>
                <p className="text-white font-bold text-xs sm:text-sm">
                  48 hours of inaction = streak dead. Recovery mode gives you <span className="text-orange-400">2× points</span>.
                </p>
              </div>

              {/* Execute Mode */}
              <div className="bg-gradient-to-r from-yellow-500/20 to-orange-500/20 border-2 border-yellow-500 p-3 sm:p-4">
                <div className="flex items-center gap-2 mb-2">
                  <div className="text-2xl sm:text-3xl">⏱️</div>
                  <h3 className="text-base sm:text-xl font-black text-yellow-400 uppercase">No Hesitation</h3>
                </div>
                <p className="text-white font-bold text-xs sm:text-sm">
                  10 second countdown forces decisions.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-lime-500 to-yellow-400 px-3 sm:px-4 py-2 mb-4 sm:mb-5 skew-x-[-3deg]">
              <p className="text-black text-sm sm:text-base md:text-lg font-black uppercase skew-x-[3deg]">
                READY TO STOP BITCHING OUT?
              </p>
            </div>

            <button
              onClick={() => {
                storage.setOnboardingComplete(true);
                setShowOnboarding(false);
                if (!username) {
                  setShowUsernameSetup(true);
                }
              }}
              className="w-full bg-gradient-to-r from-lime-500 to-green-600 hover:from-lime-400 hover:to-green-500 text-black py-4 sm:py-5 font-black text-lg sm:text-xl uppercase border-3 border-lime-400 transition-all"
            >
              🔥 LET'S GO 🔥
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
